import { render, staticRenderFns } from "./SocketError.vue?vue&type=template&id=51bb4608&scoped=true"
import script from "./SocketError.vue?vue&type=script&lang=js"
export * from "./SocketError.vue?vue&type=script&lang=js"
import style0 from "./SocketError.vue?vue&type=style&index=0&id=51bb4608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bb4608",
  null
  
)

export default component.exports